<div class="grid-y availability closed-container">
  <div class="cell small-11 small-centered medium-6 large-5 columns text-center thank-you">
    <h5 class="non-cap">{{'gather.job-closed.sorry' | translate}}</h5>
    <div class="text">{{'gather.job-closed.sorry-text' | translate}}</div>
  </div>
  <div class="cell small-8 medium-10 large-4 callout">
    <div class="row medium-margin">
      <div class="small-12 small-centered text-center columns">
        <img src="../../../assets/images/gather/see_more_jobs.png" class="material-icons large" />
      </div>
    </div>
    <div class="cell medium-margin">
      <div class="small-12 small-centered text-center large-margin columns">
        <h5 class="small-margin">{{'gather.see-more-jobs' | translate}}</h5>
        <div class="text">{{'gather.see-more-jobs-text' | translate}}
        </div>
      </div>
    </div>
    <div class="cell medium-margin">
      <div class="small-12 small-offset-0 large-offset-3 medium-8 medium-offset-1 large-6 columns">
        <button class="btn-1" (click)="goToUrl('job')">
          <span>{{'gather.visit-job-center' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</div>
